import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="form"
export default class extends Controller {
  static targets = ['cancel']

  submit (event) {
    this.element.requestSubmit()
  }

  cancel () {
    if (this.hasCancelTarget) this.cancelTarget.click()
  }
}
